export default {
    list: {
        title: "Shippings",
        name: 'shippings',
        class: "min-h-screen flex-1 mt-1 bg-gray-100 px-3 items-center",
        sousTable: true,
        options: {
            defaultPageSize: 5,
            actions: {
                isActive: true,
                method: true,
                name: "Actions",
                buttons: [
                    {
                        text: "Change status",
                        icon: "update",
                        action:"changestatus",
                        color: 'primary',
                        class:''
                    },
                    {
                        text: "Print the list",
                        icon: "print",
                        action:"print",
                        color: 'primary',
                        class:''
                    },
                    {
                        text: "Print Delivry Note",
                        icon: "print",
                        action:"printdDelivry",
                        color: 'primary',
                        class:''
                    },
            ],
            }
        },
        columns: [
            {
             type:"checkbox",
             elements: [{
                items: [{
                    class: "",
                    type: "checkbox",
                }, ],
            }, ]
            },
            {
                name: "Order ID",
                elements: [{
                    items: [{
                        class: "",
                        name: "order_id",
                        type: "text",

                    }, ],
                }, ]
            },
            {
                name: "Seller",
                elements: [{
                    items: [{
                        class: "ouka",
                        name: "seller",
                        elements: [{
                            items: [{
                                name: "fullName",
                                class: "font-bold text-gray-700",
                                icone: "contacts"
                            },
                            // {
                            //     name: "email",
                            //     class: "font-light text-gray-700",
                            //     icone: "email"
                            // }
                        ]
                        }]

                    }, ],
                }, ]
            },
            // {
            //     name: "Shipping Addresses",
            //     elements: [{
            //         items: [{
            //             class: "",
            //             name: "address",
            //             type: "text",

            //         }, ],
            //     }, ]
            // },
            {
                name: "Shipping date",
                elements: [{
                    items: [{
                        class: "",
                        date: true,
                        name: "date",
                        type: "text",
                    }, ],
                }, ]
            },
            {
                name: "Traking number",
                elements: [{
                    items: [{
                        class: "",
                        name: "trackingNumber",
                        type: "text",
                    }, ],
                }, ]
            },
            {
                name: "Order", //order
                model: "shippings",
                title: 'Products'
            },
            {
                name: "Zone",
                class: "",
                elements: [{
                    items: [{
                        class: "",
                        name: "zone",
                        elements: [{
                            items: [{
                                    name: "name",
                                    class: "font-bold",
                                    iconeimg: "https://img.icons8.com/external-kmg-design-basic-outline-kmg-design/64/000000/external-map-back-to-school-kmg-design-basic-outline-kmg-design.png"
                                },
                                // {
                                //     name: "price",
                                //     class: "font-light text-gray-700",
                                //     icone: "attach_money"
                                // }
                            ]
                        }]
                    }],
                }, ]
            },
            {
                name: "Courier",
                class: "",
                elements: [{
                    items: [{
                        class: "",
                        name: "courier",
                        elements: [{
                            items: [{
                                name: "fullName",
                                class: "font-bold",
                                iconeimg: "https://img.icons8.com/external-stick-figures-gan-khoon-lay/51/000000/external-courier-delivery-man-stick-figures-gan-khoon-lay.png"
                            }]
                        }]
                    }],
                }, ]
            },
            {
                name: "Type",
                elements: [{
                    items: [{
                        class: "",
                        name: "type",
                        options: (item) => {
                            switch (item) {
                                case 'normal':
                                    return "color: rgb(233 147 19);"
                                    break;
                                case 'echange':
                                    return "color:rgb(8, 194, 226)"
                                    break;
                                case 'pendingchange':
                                    return "color:rgb(106 71 9)"
                                    break;
                            }
                        },
                    }, ],
                }, ]
            },
            {
                name: "Status",
                class: "",
                elements: [{
                    items: [{
                        class: "border capitalize rounded-full text-gray-600 h-8 text-xs px-8 bg-white hover:border-gray-500 focus:outline-none appearance-none",
                        name: "status",
                        options: (item) => {
                            switch (item) {
                                case 'queued':
                                    return "color: rgb(233 147 19); border-color: rgb(233 147 19);"
                                    break;
                                case 'prepared':
                                    return "color:rgb(8, 194, 226); border-color: rgb(8, 194, 226);"
                                    break;
                                case 'shipped':
                                    return "color:rgb(106 71 9); border-color: rgb(106 71 9);"
                                    break;
                                case 'received':
                                    return "color:rgb(58 217 18); border-color: rgb(58 217 18);"
                                    break;
                                case 'paid':
                                    return "color:rgb(194, 168, 27); border-color: rgb(194, 168, 27);"
                                    break;
                                case 'refunded':
                                        return  "color:rgb(150 15 227); border-color: rgb(150 15 227);" 
                                        break;    
                                case 'reprogrammed':
                                            return  "color:rgb(10 10 10); border-color: rgb(10 10 10);" 
                                        break;    
                                case 'processed':
                                    return "color:rgb(215, 26, 230); border-color: rgb(215, 26, 230);"
                                    break;            
                                case 'cancelled':
                                    return "color: rgb(255, 5, 5); border-color: rgb(255, 5, 5);"
                                    break;
                            }
                        },
                    }],
                }, ]
            },
        ],
        columnsDialog: {
            details: 'order',
            name: "details",
            elements: [
                // {
                //     class: "",
                //     name: "Order ID",
                //     referent: "order",
                //     items: [{
                //         name: "id",
                //     }, ]
                // },
                // {
                //     class: "",
                //     name: "SELLER",
                //     referent: "order",
                //     attribut: 'seller',
                //     items: [{
                //         class: "",
                //         elements: [{
                //             items: [{
                //                     name: "fullName",
                //                     class: "font-bold text-gray-700",
                //                     icone: "contacts"
                //                 },
                //                 {
                //                     name: "email",
                //                     class: "font-light text-gray-700",
                //                     icone: "email"
                //                 }
                //             ]
                //         }]
                //     }, ]
                // },
                {
                    class: "",
                    name: "CUSTOMER",
                    referent: "order",
                    attribut: 'customer',
                    items: [{
                        class: "",
                        elements: [{
                            items: [{
                                    name: "fullName",
                                    class: "font-bold",
                                    icone: "contacts"
                                },
                                {
                                    name: "phone",
                                    class: "font-light text-gray-700",
                                    icone: "local_phone"
                                }
                            ]
                        }]
                    }, ]
                },
                {
                    class: "",
                    name: "SHIPPING ADDRESS",
                    referent: "order",
                    attribut: 'customer',
                    items: [{
                        name: "shippingAddress",
                    }, ]
                },
                {
                    class: "",
                    name: "TOTAL PRICE",
                    referent: "order",
                    items: [{
                        name: "totalPrice",
                    }, ]
                },
                // {
                //     class: "",
                //     name: "TOTAL Fees",
                //     referent: "order",
                //     items: [{
                //         name: "totalFees",
                //     }, ]
                // },
            ],
            sousElements: [{
                    class: "",
                    name: "Image",
                    referent: "product",
                    items: [{
                        name: "picture",
                    }, ]
                },
                {
                    class: "",
                    name: "Name",
                    referent: "product",
                    items: [{
                        name: "name",
                    }, ]
                },
                // {
                //     class: "",
                //     name: "Code",
                //     referent: "product",
                //     items: [{
                //         name: "code",
                //     }, ]
                // },
                // {
                //     class: "",
                //     name: "Unit price",
                //     items: [{
                //         name: "unitPrice",
                //     }, ]
                // },
                {
                    class: "",
                    name: "Quantity",
                    items: [{
                        name: "quantity",
                    }, ]
                },
            ]
        },
        actions: {
            name: "Actions",
            width: "10px",
            class: "justify-end",
            elements: [
                // {
                //     icone: "print",
                //     color: "success",
                //     key: 'print',
                //     role: true,
                //     id: "",
                //     tooltip: "Print",
                // },
                {
                    icone: "remove_red_eye",
                    color: "success",
                    key: 'read',
                    id: "",
                    role: true,
                    link: '/shippings/view',
                    tooltip: "Update",
                },
                {
                    icone: "edit",
                    color: "success",
                    role: true,
                    key: 'update',
                    link: '/shippings/edit',
                    tooltip: "Update",
                },
                {
                    icone: "delete",
                    color: "danger",
                    role: true,
                    key: 'delete',
                    tooltip: "Delete",
                }
            ],
        },
        filters: {
            name: 'zones',
            hasFilterdate:true,
            elements: {
                search: {
                    options: {
                        icon: "search",
                        label: "search",
                        class: "",
                        hint: "Order ID, Customer name, Customer phone, Shipping Addresses, Traking number...",
                    },
                    value: null,
                    type: "search",
                    validate: {
                        trim: true,
                        required: false,
                        minlength: 0,
                    }
                },
                champs: [
                    {
                        label: "Status",
                        key: "status",
                        value: null,
                        values: [],
                        class: 'py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white',
                        type: "select",
                    },
                    {
                        label: "Seller",
                        key: "seller",
                        name: "fullName",
                        value: null,
                        values: [],
                        class: 'py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white',
                        type: "select",
                    },
                    {
                        label: "Product",
                        key: "product",
                        name: "name",
                        value: null,
                        values: [],
                        class: 'py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white',
                        type: "select",
                    },
                   
                    {
                        label: "couriers",
                        key: "courier",
                        name: "fullName",
                        value: null,
                        values: [],
                        class: 'py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white',
                        type: "select",
                    },
                    {
                        label: "Zones",
                        key: "zone",
                        name: "name",
                        value: null,
                        values: [],
                        class: 'py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white',
                        type: "select",
                    },
                    {
                        label: "Type",
                        key: "type",
                        name: "type",
                        value: null,
                        values: [],
                        class: 'py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white',
                        type: "select",
                    },
                    {
                        label: "Shipping date",
                        key: "Range_date",
                        value: null,
                        placeholder: "Date Range ...",
                        type: "date_range",
                        class: "py-2 text-xs px-2 outline-none block h-full w-full"
                    }
                ],
            },
        },
    },
}